import { render, staticRenderFns } from "./FXTransDetails.vue?vue&type=template&id=08c2987a&scoped=true"
import script from "./FXTransDetails.vue?vue&type=script&lang=js"
export * from "./FXTransDetails.vue?vue&type=script&lang=js"
import style0 from "./FXTransDetails.vue?vue&type=style&index=0&id=08c2987a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2987a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c2987a')) {
      api.createRecord('08c2987a', component.options)
    } else {
      api.reload('08c2987a', component.options)
    }
    module.hot.accept("./FXTransDetails.vue?vue&type=template&id=08c2987a&scoped=true", function () {
      api.rerender('08c2987a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/FXTransDetails.vue"
export default component.exports